import { getBlogItemProps } from "../LatestPosts/transform";

export default (blogList = [], header = "Featured Posts") => {
	return {
		header,
		blogList: getBlogItemProps(blogList),
	};
};
